<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '90vh'}" styleClass="custombar1 ">
  <div class="container-fluid">
    <!-- Mensaje Paso 1-->
    <div class="alert" [ngClass]="'alert-info'" role="alert" *ngIf="currentStep == 1">
      <div class="row">
        <div class="col-12">
          <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i>
            {{'MultiTaskAction.Messages.SelectTasks' | translate}} </span>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12 text-right">
          <span
            [innerHTML]="translateService.instant('Signature.Massive.TaskSelection', {selected: task2Process.length, total: tableTasks.length} )"></span>
        </div>
      </div>
    </div>
    <!-- Mensaje Paso 2-->
    <div class="alert" [ngClass]="(errorTasks || processStatus === ProcessStatus.ABORTED) ?
        'alert-warning':
        (processStatus === ProcessStatus.FINISHED) ? 'alert-success' : 'alert-info'" role="alert"
      *ngIf="currentStep == 2">
      <div class="row">
        <div class="col-12">
          <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ getProcessMessage() }} </span>
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-6">
          <span>{{'MultiTaskAction.Tasks.Processed' | translate}} </span>{{executedTasks}}
        </div>
        <div class="col-6" *ngIf="errorTasks">
          <span>{{'Signature.Massive.Tasks.Error' | translate}} </span>{{errorTasks}}
        </div>
      </div>
      <div class="row m-t-sm">
        <div class="col-12">
          <p-progressBar [value]="progressPercentage"></p-progressBar>
        </div>
      </div>
    </div>
    <p-overlayPanel #processMsg>
      <div class="alert alert-danger" [innerHTML]="actionMessage" role="alert"></div>
    </p-overlayPanel>
    <!-- LISTA DE TAREAS -->
    <div class="row">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="actionTasksTemplate"></ng-container>
      </div>
    </div>
  </div>
</p-scrollPanel>
<!-- LISTADO DE TAREAS DE FIRMA-->
<ng-template #actionTasksTemplate>
  <p-table [value]="tableTasks" [paginator]="false" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 60, 100]"
    class="footer-over-pagination" sortField="arrivalDate" sortOrder="-1" [scrollable]="false"
    responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-icon text-center">
          <p-checkbox *ngIf="currentStep == 1" inputId="selectAllCtrl" binary="true" [(ngModel)]="allSelected"
            (ngModelChange)="selectAll ()">
          </p-checkbox>
        </th>
        <th [ngClass]="(descriptionClass) ? descriptionClass: 'w-75'" [pSortableColumn]="'description'">
          <span class="d-none d-md-table-cell ">{{ 'PendingTasks.description' | translate }}</span>
          <span class="d-md-none">{{ 'Seleccionar todas' | translate }}</span>
        </th>
        <th [ngClass]="(arrivalDateClass) ? arrivalDateClass : 'd-none d-md-table-cell  text-center'"
          style="width:110px" [pSortableColumn]="'arrivalDate'"> {{ 'PendingTasks.arrival' | translate }} </th>
        <th [ngClass]="(endDateClass) ? endDateClass : 'd-none d-md-table-cell  text-center'" style="width:110px"
          [pSortableColumn]="'expirationDate'"> {{ 'PendingTasks.endDate' | translate }} </th>
        <!-- Columnas configurables json -->
        <ng-container *ngIf="this.columnsConfig">
          <ng-container *ngFor="let colConfig of this.columnsConfig">
            <th [class]="colConfig.class"> {{colConfig.descriptionKey | translate}} </th>
          </ng-container>
        </ng-container>
        <!-- Boton ver docs de tarea -->
        <ng-container *ngIf="currentStep == 1 && this.viewDocumentsTask">
          <th class="d-none d-md-table-cell  t-action-button text-center"> {{this.viewDocumentsTask.descriptionKey |
            translate}} </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task>
      <tr (mouseover)="(currentStep == 2) ? showActionMessage(task, $event, processMsg) : undefined"
        (mouseout)="(currentStep == 2) ? processMsg.hide() :undefined">
        <td class="col-icon text-center">
          <p-checkbox *ngIf="currentStep == 1" inputId="{{ task.identifier }}" binary="true"
            [ngModelOptions]="{ standalone: true }" [ngModel]="task[SELECTED_PROPERTY]"
            (onChange)="selectTask (task, $event.checked)">
          </p-checkbox>
          <span *ngIf="currentStep == 2" class="d-inline-block">
            <a [class]="getStatusIcon(task)"></a>
          </span>
        </td>
        <!-- COLUMNA Descripcion -->
        <td [ngClass]="(descriptionClass) ? descriptionClass: ''">
          <!-- 1. DESCRIPCION DE LA TAREA CON ENLACE DE PAERTURA SI LA TAREA ESTA ACTIVA -->
          <div class="taskName {{this.userService.hasInbox(task.inbox.identifier)?' text-primary':''}}">
            <span>{{ task?.description }}</span>
          </div>
          <!-- 2. DATOS DEL EXPEDIENTE Y ESTRUCTURA DE DIVISIONES -->
          <div class="taskDetailInfo">
            <divisionDetail class="taskDossier" [division]="task.division" [showDivisionInfo]="true" [infoLink]="false">
            </divisionDetail>
          </div>
          <!-- 3. SI LA TAREA ESTA BLOQUEADA DATOS DEL USUARIO QUE TIENE LA TAREA -->
          <div class="taskDetailInfo" *ngIf="task?.status === 'LOCKED' && task?.lockedBy">
            <span>
              <i class="fa fa-lock text-danger" aria-hidden="true"></i> {{ 'Tasks.lockedBy' | translate }}: {{
              userService.calculateUserFullName(task?.lockedBy) }} </span>
          </div>
          <!-- 4. EN MOVIL FECHAS DE LLEGADA Y VENCIMIENTO -->
          <div class="d-md-none">
            <div class="taskDetailInfo">
              <b>{{ 'PendingTasks.arrival' | translate }}:</b> {{ task.arrivalDate | date: 'dd/MM/y HH:mm' }}
            </div>
            <div class="taskDetailInfo" *ngIf="task.expirationDate">
              <b>{{ 'PendingTasks.endDate' | translate }}:</b>
              <span> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </span>
            </div>
          </div>
        </td>
        <!-- COLUMNA fecha llegada -->
        <td [ngClass]="(arrivalDateClass) ? arrivalDateClass : 'd-none d-md-table-cell'"> {{ task.arrivalDate | date:
          'dd/MM/y HH:mm' }} </td>
        <!-- COLUMNA fecha expiracion -->
        <td [ngClass]="(endDateClass) ? endDateClass : 'd-none d-md-table-cell'">
          <div *ngIf="task.expirationDate"> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </div>
          <div *ngIf="!task.expirationDate" class="text-center"> - </div>
        </td>
        <ng-container *ngIf="this.columnsConfig">
          <ng-container *ngFor="let colConfig of this.columnsConfig">
            <td> {{ (task[ATTRIBUTE_PROPERTY] && colConfig.attributeColumn &&
              task[ATTRIBUTE_PROPERTY].columns[colConfig.attributeColumn]) ?
              task[ATTRIBUTE_PROPERTY].columns[colConfig.attributeColumn]['value'] : '' }} </td>
          </ng-container>
        </ng-container>
        <!-- Columna acceso a los documentos de la tarea-->
        <ng-container *ngIf="currentStep == 1 && this.viewDocumentsTask">
          <td [ngClass]="this.viewDocumentsTask.class">
            <div>
              <div class="btn-group">
                <button class="btn btn-sm btn-primary t-action-button" (click)="viewDocument(task)"
                  aria-label="{{'DocumentsAction.view' | translate}}">
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td colspan="6">{{ 'General.noFilteredData' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>